import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import ReadMore from '../readMore'
import ReviewStars from '../reviews/reviewStars'

import styles from './productReviewHighLight.module.scss'

export interface ProductReviewHighLightProps {
  title: string
  avgRating: number
  children: string
  className?: string
  brandName?: string
}

const ProductReviewHighLight = ({ children, className, avgRating, title, brandName }: ProductReviewHighLightProps) => {
  const { t } = useTranslation('common')
  const classes = classnames(styles.container, className)

  return (
    <div className={classes}>
      <ReviewStars totalStars={5} fillStars={avgRating} />
      <div className={styles.container__title}>{title}</div>
      <ReadMore className={styles.container__body}>{children}</ReadMore>
      {brandName && (
        <p className={styles.brandName}>
          {t('customer_review_from')} {brandName}
        </p>
      )}
    </div>
  )
}
export default ProductReviewHighLight
